import { Box, Flex } from "@chakra-ui/react";
import ChecklistItems from "components/loans/ChecklistItems";
import LoanTargetBox from "components/loans/LoanTargetBox";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { permissionConstants, hasPermission } from "utils/permissionHelper";

const LoanChecklist = ({
  canEdit = false,
  canView = false,
  canAdd = false,
}: {
  canEdit?: boolean;
  canView?: boolean;
  canAdd?: boolean;
}) => (
  <Box>
    <Flex gap={4} align="flex-start">
      <Box flex="1" minW="0">
        <ChecklistItems canAdd={canAdd} canEdit={canEdit} canView={canView} />
      </Box>
      <Box pr="24px">
        <LoanTargetBox />
      </Box>
    </Flex>
  </Box>
);

const ChecklistTab = () => {
  const { user } = useTenant();

  const canEditChecklist = hasPermission(user, permissionConstants.editChecklist);
  const canAddChecklist = hasPermission(user, permissionConstants.addChecklist);
  const canViewChecklist = canAddChecklist || canEditChecklist;

  return (
    <Box>
      <LoanChecklist
        canEdit={canEditChecklist}
        canView={canViewChecklist}
        canAdd={canAddChecklist}
      />
    </Box>
  );
};

export default ChecklistTab;
